import { Injectable } from '@angular/core';
import { SharedEventNameEnum } from '@smarttask-common/src/lib/models/AngularSpecific/SharedEventNameEnum';
import { ProjectDetailModel } from '@smarttask-common/src/lib/models/Project/ProjectDetailModel';
import { UpdateIconColorModel } from '@smarttask-common/src/lib/models/General/UpdateIconColorModel';
import { CustomFieldValueModel } from '@smarttask-common/src/lib/models/CustomFieldValue/CustomFieldValueModel';
import { ProjectDateModel } from '@smarttask-common/src/lib/models/Project/ProjectDateModel';
import { ProjectSchedulingEnum } from '@smarttask-common/src/lib/models/Project/Enums/ProjectSchedulingEnum';
import { OrganizationHubBase } from './organizationHubBase';

@Injectable({
    providedIn: 'root',
})
export class ProjectHubService extends OrganizationHubBase {
    protected subscribe_event = SharedEventNameEnum.project_subscribe;
    protected unsubscribe_event = SharedEventNameEnum.project_unsubscribe;

    constructor() {
        super();
        this.init();
    }

    protected registerHandlers = () => {
        this.on(SharedEventNameEnum.project_create, (project_id: string) => {
            this.broadcast(SharedEventNameEnum.project_create, { project_id });
        });

        this.on(SharedEventNameEnum.project_copied, (old_project_id: string, new_project_id: string) => {
            this.broadcast(SharedEventNameEnum.project_copied, { old_project_id, new_project_id });
        });

        this.on(SharedEventNameEnum.project_name_update, (project_id: string, name: string) => {
            this.broadcast(SharedEventNameEnum.project_name_update, { project_id, name });
        });

        this.on(SharedEventNameEnum.project_order_update, (project_id: string, order_index: number) => {
            this.broadcast(SharedEventNameEnum.project_order_update, { project_id, order_index });
        });

        this.on(SharedEventNameEnum.project_details_update, (project_id: string, project_detail: ProjectDetailModel) => {
            this.broadcast(SharedEventNameEnum.project_details_update, { project_id, project_detail });
        });

        this.on(SharedEventNameEnum.project_description_update, (project_id: string, description: string) => {
            this.broadcast(SharedEventNameEnum.project_description_update, { project_id, description });
        });

        this.on(SharedEventNameEnum.project_dates_update, (project_id: string, dates: ProjectDateModel) => {
            this.broadcast(SharedEventNameEnum.project_dates_update, { project_id, dates });
        });

        this.on(SharedEventNameEnum.project_owner_update, (project_id: string, owner_user_id: number) => {
            this.broadcast(SharedEventNameEnum.project_owner_update, { project_id, owner_user_id });
        });

        this.on(SharedEventNameEnum.project_icon_color_update, (project_id: string, project_icon_color: UpdateIconColorModel) => {
            this.broadcast(SharedEventNameEnum.project_icon_color_update, { project_id, project_icon_color });
        });

        this.on(SharedEventNameEnum.project_parent_update, (project_id: string, parent_project_id: string) => {
            this.broadcast(SharedEventNameEnum.project_parent_update, { project_id, parent_project_id });
        });

        this.on(SharedEventNameEnum.project_scheduling_update, (project_id: string, scheduling_type: ProjectSchedulingEnum) => {
            this.broadcast(SharedEventNameEnum.project_scheduling_update, { project_id, scheduling_type });
        });

        this.on(SharedEventNameEnum.project_move_due_date_on_completion, (project_id: string, move_due_date_on_completion: boolean) => {
            this.broadcast(SharedEventNameEnum.project_move_due_date_on_completion, { project_id, move_due_date_on_completion });
        });

        this.on(SharedEventNameEnum.project_custom_field_value_update, (project_id: string, custom_field_value: CustomFieldValueModel) => {
            this.broadcast(SharedEventNameEnum.project_custom_field_value_update, { project_id, custom_field_value });
        });

        this.on(SharedEventNameEnum.project_sprint_config_update, (project_id: string) => {
            this.broadcast(SharedEventNameEnum.project_sprint_config_update, { project_id });
        });

        this.on(SharedEventNameEnum.project_archive_update, (project_id: string, archived: boolean) => {
            this.broadcast(SharedEventNameEnum.project_archive_update, { project_id, archived });
        });

        this.on(SharedEventNameEnum.project_delete, (project_id: string) => {
            this.broadcast(SharedEventNameEnum.project_delete, project_id);
        });
    };
}
